function getPageName(path) {
  switch (path) {
    case "/dashboard":
      return "Dashboard";
    case "/videos":
      return "Mídias";
    case "/perguntas":
      return "Perguntas";
    case "/pessoas":
      return "Pessoas";
    case "/voucher":
      return "Vouchers";
    case "/radios":
      return "Vagalumes";
    case "/maps":
      return "Mapas";
    case "/clientes":
      return "Clientes";
    case "/usuarios":
      return "Usuários";
    case "/notifications":
      return "Alertas";
    case "/testes":
      return "Testes";
    case "/settings":
      return "Configurações";
    default:
      return "login";
  }
}

export { getPageName };



// WEBPACK FOOTER //
// ./src/functions/pathsName.js